module.exports = __webpack_public_path__ + "static/media/trailer_view_dark.54ef62fe.svg";